import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Builder from "@/pages/Builder";
import Dashboard from "@/pages/Dashboard";
import Sample from "@/pages/Sample";
import Sign from "@/pages/Sign";
import ArticlePage from "@/pages/ArticlePage";
import Admin from "@/pages/Admin";
import LegalPage from "@/pages/LegalPage";
import ByState from "@/pages/ByState";
import Calculator from "@/pages/Calculator";
import Analytics from "@/components/Analytics";
import ScrollToTop from "@/components/ScrollToTop";
import { useParams } from "react-router-dom";

// State-aware wrapper for /private-sale-car-value-calculator/:stateSlug
function CalculatorStateWrapper() {
  const { stateSlug } = useParams();
  const valid = ["california", "texas", "florida", "new-york"];
  if (!valid.includes(stateSlug)) return <Calculator />;
  return <Calculator stateSlug={stateSlug} />;
}

function App() {
  // Toaster (sonner) renders runtime-derived strings (e.g. `aria-label`
  // "Notifications alt+T") that differ between the prerender environment and
  // the user's browser, which would trigger React 19 hydration mismatch
  // errors (#418). Render it only after the first client mount so it's never
  // part of the SSR payload.
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        {hasMounted && <Toaster position="top-right" richColors />}
        <BrowserRouter>
          <ScrollToTop />
          <Analytics />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/car-bill-of-sale" element={<Landing variant="main" />} />
            <Route path="/by-state" element={<ByState />} />
            <Route path="/private-sale-car-value-calculator" element={<Calculator />} />
            <Route path="/private-sale-car-value-calculator/:stateSlug" element={<CalculatorStateWrapper />} />
            <Route path="/california-car-bill-of-sale" element={<Landing stateName="California" />} />
            <Route path="/california-car-bill-of-sale/:slug" element={<ArticlePage stateSlug="california" />} />
            <Route path="/texas-car-bill-of-sale" element={<Landing stateName="Texas" />} />
            <Route path="/texas-car-bill-of-sale/:slug" element={<ArticlePage stateSlug="texas" />} />
            <Route path="/florida-car-bill-of-sale" element={<Landing stateName="Florida" />} />
            <Route path="/florida-car-bill-of-sale/:slug" element={<ArticlePage stateSlug="florida" />} />
            <Route path="/new-york-car-bill-of-sale" element={<Landing stateName="New York" />} />
            <Route path="/new-york-car-bill-of-sale/:slug" element={<ArticlePage stateSlug="new-york" />} />
            <Route path="/builder/:id" element={<Builder />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/sample-pdf" element={<Sample />} />
            <Route path="/sign/:id/:role" element={<Sign />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/about" element={<LegalPage which="about" />} />
            <Route path="/contact" element={<LegalPage which="contact" />} />
            <Route path="/privacy" element={<LegalPage which="privacy" />} />
            <Route path="/terms" element={<LegalPage which="terms" />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
